    export const formatDate = (dateString) => {
        const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Los_Angeles",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
        });
        
        const laDate = formatter.formatToParts(new Date(dateString));

        const [year, month, day, hour, minute, second] = [
            laDate.find(part => part.type === "year")?.value,
            laDate.find(part => part.type === "month")?.value,
            laDate.find(part => part.type === "day")?.value,
            laDate.find(part => part.type === "hour")?.value,
            laDate.find(part => part.type === "minute")?.value,
            laDate.find(part => part.type === "second")?.value
        ];

        return `${year}-${month}-${day}T${hour}:${minute}:${second}.000`;
    }